<template>
  <el-table-column
    prop="customer_address"
    label="Cím"
    show-overflow-tooltip
    min-width="250"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.customer_address }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'customer_address.street',
  };
</script>
